// const URL = "https://stage.myciright.com/Ciright";
const URL = "https://www.myciright.com/Ciright";

const AppConfig = {
  API: {
    ENDPOINT: URL + "/api",
    USER_PROFILE:
      URL +
      "/ajaxCall-photo.htm?flag=employeePhoto&compress=0&colorCode=veuit&id=",

    SUBSCRIPTION_ID: 8106995,
    VERTICAL_ID: 2764,
    APP_ID: 2766,
    SPHERE_TYPE_URL: "electric-factory-drexel-exhibit-website.htm",
    SPHERE_TYPE_ID: 2,
  },
};

export default AppConfig;
